import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Impersonation bootstrap page.
 * Admin opens this URL in a new tab with tokens in query params.
 * This page writes tokens into sessionStorage (isolated per tab),
 * strips the URL params, and redirects to /dashboard.
 */
export default function ImpersonatePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const at = params.get("at");
    const rt = params.get("rt");
    const email = params.get("email") || "";
    const name = params.get("name") || "";
    if (!at || !rt) {
      navigate("/login", { replace: true });
      return;
    }
    try {
      sessionStorage.setItem("impersonating", "1");
      sessionStorage.setItem("access_token", at);
      sessionStorage.setItem("refresh_token", rt);
      sessionStorage.setItem("imp_email", email);
      sessionStorage.setItem("imp_name", name);
    } catch { /* ignore */ }
    // Strip query params from URL for privacy, then route to dashboard
    window.history.replaceState({}, "", "/dashboard");
    // Full reload so AuthContext re-initializes with sessionStorage tokens
    window.location.replace("/dashboard");
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0B0E14] flex items-center justify-center">
      <p className="text-sm text-[#94A3B8]" data-testid="impersonate-loading">Switching account…</p>
    </div>
  );
}
